import React from 'react';

// NOTE: v1 placeholder artwork. Designer pass pending.
export default function SpringAccessory() {
  return (
    <g aria-hidden="true">
      {/* Big white daisy centred on roof */}
      <g transform="translate(100 76)">
        <ellipse cx="0" cy="-11" rx="6" ry="9" fill="#F9FCF1" stroke="#dde0d5" strokeWidth="0.8" />
        <ellipse cx="9.5" cy="-5.5" rx="6" ry="9" fill="#F9FCF1" stroke="#dde0d5" strokeWidth="0.8" transform="rotate(60 9.5 -5.5)" />
        <ellipse cx="9.5" cy="5.5" rx="6" ry="9" fill="#F9FCF1" stroke="#dde0d5" strokeWidth="0.8" transform="rotate(120 9.5 5.5)" />
        <ellipse cx="0" cy="11" rx="6" ry="9" fill="#F9FCF1" stroke="#dde0d5" strokeWidth="0.8" />
        <ellipse cx="-9.5" cy="5.5" rx="6" ry="9" fill="#F9FCF1" stroke="#dde0d5" strokeWidth="0.8" transform="rotate(60 -9.5 5.5)" />
        <ellipse cx="-9.5" cy="-5.5" rx="6" ry="9" fill="#F9FCF1" stroke="#dde0d5" strokeWidth="0.8" transform="rotate(120 -9.5 -5.5)" />
        <circle cx="0" cy="0" r="5.5" fill="#E5B941" stroke="#CD7F32" strokeWidth="0.8" />
      </g>
      {/* Smaller yellow daffodil to the right */}
      <g transform="translate(135 90)">
        <ellipse cx="0" cy="-7" rx="4" ry="6" fill="#E5B941" stroke="#CD7F32" strokeWidth="0.8" />
        <ellipse cx="6" cy="-3.5" rx="4" ry="6" fill="#E5B941" stroke="#CD7F32" strokeWidth="0.8" transform="rotate(60 6 -3.5)" />
        <ellipse cx="6" cy="3.5" rx="4" ry="6" fill="#E5B941" stroke="#CD7F32" strokeWidth="0.8" transform="rotate(120 6 3.5)" />
        <ellipse cx="0" cy="7" rx="4" ry="6" fill="#E5B941" stroke="#CD7F32" strokeWidth="0.8" />
        <ellipse cx="-6" cy="3.5" rx="4" ry="6" fill="#E5B941" stroke="#CD7F32" strokeWidth="0.8" transform="rotate(60 -6 3.5)" />
        <ellipse cx="-6" cy="-3.5" rx="4" ry="6" fill="#E5B941" stroke="#CD7F32" strokeWidth="0.8" transform="rotate(120 -6 -3.5)" />
        <circle cx="0" cy="0" r="3.5" fill="#E89A2E" />
      </g>
      {/* Smaller pink flower to the left */}
      <g transform="translate(70 90)">
        <ellipse cx="0" cy="-7" rx="4" ry="6" fill="#FFC0CB" stroke="#E89A2E" strokeWidth="0.8" />
        <ellipse cx="6" cy="-3.5" rx="4" ry="6" fill="#FFC0CB" stroke="#E89A2E" strokeWidth="0.8" transform="rotate(60 6 -3.5)" />
        <ellipse cx="6" cy="3.5" rx="4" ry="6" fill="#FFC0CB" stroke="#E89A2E" strokeWidth="0.8" transform="rotate(120 6 3.5)" />
        <ellipse cx="0" cy="7" rx="4" ry="6" fill="#FFC0CB" stroke="#E89A2E" strokeWidth="0.8" />
        <ellipse cx="-6" cy="3.5" rx="4" ry="6" fill="#FFC0CB" stroke="#E89A2E" strokeWidth="0.8" transform="rotate(60 -6 3.5)" />
        <ellipse cx="-6" cy="-3.5" rx="4" ry="6" fill="#FFC0CB" stroke="#E89A2E" strokeWidth="0.8" transform="rotate(120 -6 -3.5)" />
        <circle cx="0" cy="0" r="3.5" fill="#E0290A" />
      </g>
      {/* Small green leaves */}
      <path d="M100,98 Q108,96 110,92 Q104,93 100,98" fill="#009159" />
      <path d="M100,98 Q92,96 90,92 Q96,93 100,98" fill="#009159" />
    </g>
  );
}
